// Merged Studio workspace — combines the whiteboard Studio and The App
// (App Studio) into one tabbed hub.
import React from 'react';
import HubScreen from './HubScreen';
import Studio from './Studio';
import AppStudio from './AppStudio';

const TABS = [
  { id: 'studio', label: 'Studio',  Component: Studio },
  { id: 'theapp', label: 'The App', Component: AppStudio },
];

export default function StudioWorkspace(props) {
  return <HubScreen tabs={TABS} passProps={props} title="Studio" />;
}
